import axios from 'axios'

export const namespaced = true

export const state = {
  file: null,
  removeExistingFile: false,
  fileTwo: null,
  removeExistingFileTwo: false,
}

export const getters = {}

export const mutations = {
  setFile: (state, file) => (state.file = file),
  removeExistingFile: (state, removeExistingFile) =>
    (state.removeExistingFile = removeExistingFile),
  setFileTwo: (state, file) => (state.fileTwo = file),
  removeExistingFileTwo: (state, removeExistingFile) =>
    (state.removeExistingFileTwo = removeExistingFile),
}

export const actions = {
  maybeSaveImage: async ({ state }) => {
    if (!state.file) return
    const formData = new FormData()
    formData.append('image', state.file)
    // todo: refactor with api client, and remove global window
    const response = await axios.post(`//${window.location.host}/image`, formData, {
      headers: {
        accept: 'application/json',
        'Accept-Language': 'en-US,en;q=0.8',
        'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
      },
    })
    return response.data.url
  },
  initStateData: ({ commit }) => {
    commit('setFile', null)
    commit('removeExistingFile', false)
  },
}
